<ng-container *ngIf="data.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.Title"></span>
    <button
      *ngIf="data.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content><p *scRichText="data.BodyText"></p></div>
<div
  mat-dialog-actions
  *ngIf="
    data.SubmitButtonLabel.value !== '' || data.CancelButtonLabel.value !== ''
  "
>
  <ng-container *ngIf="data.SubmitButtonLabel.value !== ''">
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      *scText="data.SubmitButtonLabel"
      (click)="confirm()"
    ></button>
  </ng-container>
  <ng-container
    *ngIf="data.RedirectButtonLabel && data.RedirectButtonLabel.value !== ''"
  >
    <button
      class="btn btn-outline-primary btn-md-block-none"
      (click)="redirect()"
    >
      <span *scText="data.RedirectButtonLabel"></span>
    </button>
  </ng-container>
  <ng-container *ngIf="data.CancelButtonLabel.value !== ''">
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none"
      (click)="dialogRef.close()"
    >
      <span *scText="data.CancelButtonLabel"></span>
    </button>
  </ng-container>
</div>
